import { setMode, setCheckoutIntent } from 'store/login-modal/actions'
import { toggleModal } from 'store/ui/actions'
import { PLANS } from 'server/lib/constants'
import { userIsAtLeast } from 'lib/user'

// Label for a paywall CTA that offers the free trial. Flat if/else (not a nested
// ternary) so prettier 2 and 3 format it identically.
export const trialCtaLabel = user => {
  if (userIsAtLeast(user, PLANS.premium)) return 'Log in'
  if (user?.activatedTrial) return 'Upgrade'
  return 'Start Free Trial'
}

// determine whether to pop up the login or upgrade modal.
//
// recordTrialIntent: only pass true from buttons that literally say "Start Free
// Trial". It records a Basic-monthly checkout intent so a logged-out user is
// resumed into trial checkout after signup (SCI-3378) — otherwise the account
// is created with no trial ever started. Leave false for the feature-gate
// interceptions this helper also backs (Explain, upload, example questions,
// hero) so signing up from those does not force an unexpected Stripe redirect.
const loginActivateOrUpgrade = (user, dispatch, context, { recordTrialIntent = false } = {}) => {
  if (!user?.email) {
    if (recordTrialIntent) {
      dispatch(setCheckoutIntent({ plan: PLANS.basic, annual: false }))
    }
    dispatch(setMode('register'))
    dispatch(toggleModal('login', true, context))
  } else {
    dispatch(toggleModal('upgrade', true, context))
  }
}

export default loginActivateOrUpgrade
